import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.scss']
})
export class VoucherComponent implements AfterViewInit {

  public company_uuid;
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService, private cdr : ChangeDetectorRef) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });
   }

  ngAfterViewInit(): void {
      this.init();
  }

  async init() {
    const setting = 
        { post: {url: "/admin/app/voucher/get", data: {page_nat: true, uuid: this.company_uuid}},
          disabled_pagenat: false,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Voucher Code', type: 'string', key: 'voucher_code', filter: "string"}, 
            {label: 'Player Code', type: 'string', key: 'player_code'}, 
            {label: 'Remark', type: 'string', key: 'remark'}, 
            {label: 'Winning', type: 'string', key: 'winning'}, 
            {label: 'Create On', type: 'date', key: 'create_on'}, 
            {label: 'Claim On', type: 'timestamp', key: 'update_on'}, 
            {label: 'Status', type: 'voucher', key: 'status'}, 
            {label: 'View', type: 'link', key: 'uuid', 'link': '/lo' + (this.company_uuid ? '/' + this.company_uuid : '/null') + "/voucher/form", hide: true},
            {label: 'Delete', type: 'delete', key: 'uuid', table: 'player_voucher', title: 'voucher_code', hide: true},
          ]}
      this.tb.init(setting);
      setTimeout(() => {
       // this.cdr.detectChanges();
      }, 100)
  }


}
